<template>
  <div class="navbar-container d-flex content align-items-center">

    <b-avatar
      :src="appLogoImageUrl"
      size="lg"
    />
    <!-- Bookmarks Container -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 ml-1">
      <b-navbar-nav class="nav">
        <b-nav-item
          v-for="(bookmark, index) in navMenuItems"
          :id="`bookmark-${index}`"
          :key="index"
          :to="{name : bookmark.route }"
        >
          <feather-icon
            :icon="bookmark.icon"
            size="21"
          />
          <b-tooltip
            triggers="hover"
            :target="`bookmark-${index}`"
            :title="$t(bookmark.title)"
            :delay="{ show: 100, hide: 50 }"
          />
        </b-nav-item>
      </b-navbar-nav>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <!-- <dark-Toggler /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BNavbarNav, BNavItem, BTooltip, BAvatar,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
// import Locale from './components/Locale.vue'
import UserDropdown from '@/views/layouts/app-navbar/components/UserDropdown.vue'
import { navMenuItems } from '@/vue.router'

export default {
  components: {
    BNavbarNav,
    BNavItem,
    BTooltip,
    BAvatar,
    // Locale,
    // DarkToggler,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const { appName, appLogoImageUrl } = $themeConfig.app

    return {
      navMenuItems,
      appName,
      appLogoImageUrl,
    }
  },
}
</script>
<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
